import { Code, ConnectError } from '@connectrpc/connect'

const maxRetries = 3
const connectRetryableErrorCodes = [
  Code.PermissionDenied,
  Code.NotFound,
  Code.AlreadyExists,
  // The session-token interceptor already refreshes + replays once on a 401 (ENG-3820); a surfaced
  // Unauthenticated means that recovery failed, so retrying with the same stale token is pure churn.
  Code.Unauthenticated,
  // The client aborted the request; retrying a request the caller no longer wants is pure churn.
  Code.Canceled,
]

export const retryLogic = (failureCount: number, error: unknown) => {
  if (error instanceof ConnectError) {
    // Don't retry for specific error codes where retrying won't help
    if (connectRetryableErrorCodes.includes(error.code)) {
      return false
    }
  }

  return failureCount < maxRetries
}
